import filterConstants from '../constants';

const history = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.history,
  properties: {
    [filterConstants.PROPERTY.event]: '',
    [filterConstants.PROPERTY.resource_id]: '',
    [filterConstants.PROPERTY.date]: '',
    [filterConstants.PROPERTY.time]: '',
  },
});

export default history;
